import React from 'react'
import { Link } from 'react-router-dom'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { PROVIDER_SECTION_BREADCRUMB } from './provider-breadcrumb'
import { IconEmail } from '../../../../../shared/icon/icon'
import { useApiFormProviderConsent, useApiListProviderConsentRequest } from '../../../../../api-new/state/auth'
import { useRoleSysProvider } from '../../../../../role/hook/role-sys'
import { useLoad } from '../../../../../shared/hooks/load'
import { WorkspaceSection } from '../../../../../shared/sso-workspace/workspace-shell'
import { FleetPage } from '../../../../../shared/sso-workspace/fleet-page'
import { ConsentRequestList } from '../../../../../shared/sso-consent/consent-request-list'

// Every consent request across the fleet (spec 2026-09-26): which
// organization, which directory, who asked, where it went and where it
// stands, with Resend / Cancel / Copy link while it is waiting and Open
// connection once approved.
export const ProviderConsentRequestList = () => {
  const roleSysProvider = useRoleSysProvider()
  const apiList = useApiListProviderConsentRequest()
  const consent = useApiFormProviderConsent()

  useLoad(() => apiList.get(), [])

  return (
    <BreadcrumbView parent={PROVIDER_SECTION_BREADCRUMB} Icon={IconEmail} text="consent requests">
      <FleetPage
        tabs
        title="Consent requests"
        purpose="Requests for an IT administrator to approve EducationXR in their Microsoft organization."
        actions={roleSysProvider.accessCreate && <Link className="btn sw-btn sw-btn-primary" to="/admin/provider/connect">New request</Link>}>
        <WorkspaceSection id="requests" title="Requests" lede="Newest first. A request can be approved for 7 days; a newer one for the same directory replaces it.">
          <ConsentRequestList
            rows={apiList.items}
            loaded={apiList.loaded !== false}
            enabled={roleSysProvider.accessCreate}
            showOrganization
            showOpenConnection
            emptyText="No consent requests yet. Start one from Connect single sign-on and it appears here with its status."
            onLink={id => consent.get(`requests/${id}/link`)}
            onResend={id => consent.postArg(`/requests/${id}/resend`, {})}
            onCancel={id => consent.postArg(`/requests/${id}/cancel`)}
            onChanged={() => apiList.get()}
          />
        </WorkspaceSection>
      </FleetPage>
    </BreadcrumbView>
  )
}
